'use strict';

export const header = (() => {
    let $topHeight = $('.js-top-h').outerHeight() / 2;
    let cr_pos = 0;
    let winH = 0;

    const scrJudge = () => {
        cr_pos = $(window).scrollTop();

        if (cr_pos > $topHeight) {
            $('body').addClass('is-scrolled');
        } else {
            $('body').removeClass('is-scrolled');
        }

        // winH = window.innerHeight;
        // contactH = $('#contact').outerHeight();
        // if (cr_pos >= wrapH - (footH + contactH + winH * 0.9)) {
        //     $('body').addClass('is-bottom');
        // } else {
        //     $('body').removeClass('is-bottom');
        // }
    }

    /**
     * init
     */
    const init = () => {

        $(window).on('load scroll', () => {
            setTimeout(() => {
                scrJudge();
            }, 100);
        });
    };

    return {
        init: init
    };
})();
